import { createBlockConnector } from './requests/create'
import { deleteBlockConnector } from './requests/delete'
import { updateBlockConnector } from './requests/update'

export { useCreateBlockConnector } from './useCreateBlockConnector'
export { useDeleteBlockConnector } from './useDeleteBlockConnector'
export {
  useUpdateBlockConnector,
  type BlockConnectorUpdateParams,
} from './useUpdateBlockConnector'
export type { UpdateBlockConnectorRequestBody } from './types'

export const blockConnectors = {
  create: createBlockConnector,
  delete: deleteBlockConnector,
  update: updateBlockConnector,
}
